import { v4 as uuidv4 } from 'uuid';

export function ProductSummaryName(props = {}, childrenComponents = []) {
	return {
		componentName: 'ProductSummaryName',
		componentId: uuidv4(),
		props: Object.assign(
			{
				showFieldsProps: {
					showSku: true,
					showProductReference: true,
					showBrandName: true,
				},
				tag: 'h2',
				blockClass: 'product-summary__name',
				mzProductName: 'Calça selva noturna roupa de inverno',
			},
			props,
		),
		childrenComponents,
	};
}
